

const defaults = {
	dataUrl: null,
	videoState: 'stopped',
	showVideoPlayer: false,
	type: 'video'
};


export default (state=defaults, action) => {
	switch(action.type){
		case 'SHOW_VIDEO_PLAYER':
			return {...state, 
				showVideoPlayer: true,
				videoState: 'load',
				dataUrl: action.payload.dataUrl,
				type: action.payload.type
			}
		case 'HIDE_VIDEO_PLAYER':
			return {...state, showVideoPlayer: false}
		default:
			return state;
	}
}





// WEBPACK FOOTER //
// ./src/reducers/videoPlayer.js